export default function ContactFormSection() {
  return (
    <section className="py-14 md:py-20 bg-[#0A2F63]">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <span className="inline-block text-xs font-medium text-[#7ED321] bg-[#7ED321]/20 px-3 py-1.5 rounded-full mb-4">
                İletişim
              </span>
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
                Temizlik ihtiyacınız için profesyonel destek alın
              </h2>
              <p className="text-base text-[#EAF2FF]/90 leading-relaxed mb-8 max-w-xl">
                Day Temizlik Adana olarak yaşam alanlarınız, apartmanlarınız, siteleriniz ve iş yerleriniz için düzenli, hijyen odaklı ve güvenilir hizmet sunuyoruz.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="tel:05539591940"
                  className="inline-flex items-center justify-center gap-2 bg-white text-[#0A2F63] px-6 py-3.5 rounded-md text-sm font-semibold hover:bg-[#EAF2FF] transition-colors whitespace-nowrap"
                >
                  <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                  0553 959 19 40
                </a>
                <a
                  href="https://wa.me/905539591940"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-[#2EA44F] text-white px-6 py-3.5 rounded-md text-sm font-semibold hover:bg-[#2EA44F]/90 transition-colors whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
                  WhatsApp'tan Yaz
                </a>
              </div>
            </div>
            <div className="relative">
              <img
                src="/assets/images/home-cta-visual.jpg"
                alt="Day Temizlik Adana profesyonel ekip"
                className="w-full h-64 md:h-80 object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}